import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "애플리케이션 개발",
  "description": "저장소에서 애플리케이션을 개발하는 방법을 알아봅니다."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "모노레포에서 애플리케이션을 개발하면 강력한 워크플로를 활용할 수 있으며, 소스 제어에 원자적 커밋을 만들고 코드에 쉽게 액세스할 수 있습니다."
  }, {
    "heading": "",
    "content": "대부분의 개발 작업은 코드 변경 사항을 감시하는 장기 실행 작업입니다. Turborepo는 강력한 터미널 UI 및 다음과 같은 기능으로 이 경험을 향상시킵니다:"
  }, {
    "heading": "",
    "content": "dev 작업 구성"
  }, {
    "heading": "",
    "content": "작업과 상호작용"
  }, {
    "heading": "",
    "content": "Watch Mode"
  }, {
    "heading": "",
    "content": "설정 스크립트 실행"
  }, {
    "heading": "",
    "content": "작업 필터링하여 패키지 하위 집합 실행"
  }, {
    "heading": "개발-작업-구성",
    "content": "turbo.json에서 개발 작업을 정의하면 Turborepo에 장기 실행 작업을 실행할 것임을 알립니다. 이는 개발 서버 실행, 테스트 실행 또는 애플리케이션 빌드와 같은 작업에 유용합니다."
  }, {
    "heading": "개발-작업-구성",
    "content": "dev 작업을 등록하려면 두 가지 속성과 함께 turbo.json에 추가합니다:"
  }, {
    "heading": "개발-작업-구성",
    "content": "\"cache\": false: Turborepo에 작업 결과를 캐시하지 않도록 지시합니다. 이는 개발 작업이므로 코드를 자주 변경할 가능성이 높기 때문에 결과를 캐시하는 것은 유용하지 않습니다."
  }, {
    "heading": "개발-작업-구성",
    "content": "\"persistent\": true: Turborepo에 중지할 때까지 작업을 계속 실행하도록 지시합니다. 이 키는 터미널 UI가 작업을 장기 실행 및 대화형으로 처리하도록 신호 역할을 합니다. 또한 종료되지 않는 작업에 실수로 의존하는 것을 방지합니다."
  }, {
    "heading": "개발-작업-구성",
    "content": "이제 dev 작업을 실행하여 개발 스크립트를 병렬로 시작할 수 있습니다:"
  }, {
    "heading": "dev-전에-설정-작업-실행",
    "content": "개발 환경을 설정하거나 패키지를 미리 빌드하는 스크립트를 실행할 수도 있습니다. dependsOn을 사용하여 dev 작업 전에 해당 작업이 실행되도록 할 수 있습니다:"
  }, {
    "heading": "dev-전에-설정-작업-실행",
    "content": "이 예에서는 Root Task를 사용하고 있지만 패키지의 임의 작업에 동일한 아이디어를 사용할 수 있습니다."
  }, {
    "heading": "특정-애플리케이션-실행",
    "content": "--filter 플래그를 사용하면 Package Graph의 하위 집합을 선택할 수 있으므로 특정 애플리케이션과 해당 종속성에 대한 dev 작업을 실행할 수 있습니다:"
  }, {
    "heading": "터미널-ui-사용",
    "content": "Turborepo의 터미널 UI는 작업을 중심으로 고도로 대화형 경험을 만드는 여러 기능을 활성화합니다."
  }, {
    "heading": "보기-사용자-지정",
    "content": "키바인드를 사용하여 필요에 맞게 UI를 빠르게 조정할 수 있습니다."
  }, {
    "heading": "보기-사용자-지정",
    "content": "키바인드"
  }, {
    "heading": "보기-사용자-지정",
    "content": "작업"
  }, {
    "heading": "보기-사용자-지정",
    "content": "m"
  }, {
    "heading": "보기-사용자-지정",
    "content": "키바인드 목록 팝업 토글"
  }, {
    "heading": "보기-사용자-지정",
    "content": "↑/↓"
  }, {
    "heading": "보기-사용자-지정",
    "content": "작업 목록에서 다음/이전 작업 선택"
  }, {
    "heading": "보기-사용자-지정",
    "content": "j/k"
  }, {
    "heading": "보기-사용자-지정",
    "content": "작업 목록에서 다음/이전 작업 선택"
  }, {
    "heading": "보기-사용자-지정",
    "content": "p"
  }, {
    "heading": "보기-사용자-지정",
    "content": "선택한 작업에 대한 선택 고정 토글"
  }, {
    "heading": "보기-사용자-지정",
    "content": "h"
  }, {
    "heading": "보기-사용자-지정",
    "content": "작업 목록 표시 토글"
  }, {
    "heading": "보기-사용자-지정",
    "content": "c"
  }, {
    "heading": "보기-사용자-지정",
    "content": "로그가 강조 표시되면 선택 항목을 시스템 클립보드에 복사"
  }, {
    "heading": "보기-사용자-지정",
    "content": "u/d"
  }, {
    "heading": "보기-사용자-지정",
    "content": "로그 위u/아래d로 스크롤"
  }, {
    "heading": "작업과-상호작용",
    "content": "일부 도구는 입력을 입력할 수 있습니다. 이에 대한 예로는 Drizzle ORM의 대화형 마이그레이션 또는 Jest의 테스트 스위트 필터링 및 재실행이 있습니다."
  }, {
    "heading": "작업과-상호작용",
    "content": "대화형으로 표시된 작업과 상호작용하여 입력을 제공할 수 있습니다."
  }, {
    "heading": "작업과-상호작용",
    "content": "키바인드"
  }, {
    "heading": "작업과-상호작용",
    "content": "작업"
  }, {
    "heading": "작업과-상호작용",
    "content": "i"
  }, {
    "heading": "작업과-상호작용",
    "content": "상호작용 시작"
  }, {
    "heading": "작업과-상호작용",
    "content": "Ctrl+z"
  }, {
    "heading": "작업과-상호작용",
    "content": "상호작용 중지"
  }, {
    "heading": "watch-mode",
    "content": "tsc --watch와 같이 많은 도구에는 소스 코드의 변경 사항에 응답하는 내장 감시자가 있습니다. 그러나 일부는 그렇지 않습니다."
  }, {
    "heading": "watch-mode",
    "content": "turbo watch는 모든 도구에 종속성 인식 감시자를 추가합니다. 소스 코드 변경 사항은 다른 모든 작업과 마찬가지로 turbo.json에 설명한 the Task Graph를 따릅니다."
  }, {
    "heading": "watch-mode",
    "content": "예를 들어 다음 작업 및 스크립트와 함께 create-turbo와 같은 패키지 구조를 사용합니다:"
  }, {
    "heading": "watch-mode",
    "content": "turbo watch dev lint를 실행하면 ESLint에 내장 감시자가 없음에도 불구하고 소스 코드를 변경할 때마다 lint 스크립트가 다시 실행됩니다. turbo watch는 내부 종속성도 인식하므로 @repo/ui의 코드 변경 사항은 @repo/ui와 web 모두에서 작업을 다시 실행합니다."
  }, {
    "heading": "watch-mode",
    "content": "web의 Next.js 개발 서버와 @repo/ui의 TypeScript 컴파일러 내장 감시자는 persistent로 표시되어 있으므로 평소와 같이 계속 작동합니다."
  }, {
    "heading": "watch-mode",
    "content": "자세한 내용은 turbo watch 참조를 방문하세요."
  }, {
    "heading": "teardown-작업",
    "content": "경우에 따라 dev 작업이 중지될 때 스크립트를 실행할 수 있습니다. dev 작업이 종료될 때 turbo가 종료되기 때문에 Turborepo는 종료 시 해당 teardown 스크립트를 실행할 수 없습니다."
  }, {
    "heading": "teardown-작업",
    "content": "대신 기본 turbo dev 작업을 종료한 후 별도로 실행하는 turbo dev:teardown 스크립트를 만듭니다."
  }, {
    "heading": "다음-단계",
    "content": "배포하려는 애플리케이션 버전이 있으면 Turborepo에서 환경 변수를 구성하는 방법을 알아볼 차례입니다."
  }],
  "headings": [{
    "id": "개발-작업-구성",
    "content": "개발 작업 구성"
  }, {
    "id": "dev-전에-설정-작업-실행",
    "content": "dev 전에 설정 작업 실행"
  }, {
    "id": "특정-애플리케이션-실행",
    "content": "특정 애플리케이션 실행"
  }, {
    "id": "터미널-ui-사용",
    "content": "터미널 UI 사용"
  }, {
    "id": "보기-사용자-지정",
    "content": "보기 사용자 지정"
  }, {
    "id": "작업과-상호작용",
    "content": "작업과 상호작용"
  }, {
    "id": "watch-mode",
    "content": "Watch Mode"
  }, {
    "id": "제한-사항",
    "content": "제한 사항"
  }, {
    "id": "teardown-작업",
    "content": "Teardown 작업"
  }, {
    "id": "다음-단계",
    "content": "다음 단계"
  }]
};
import {Tabs, Tab} from '#components/tabs';
import {LinkToDocumentation} from '#components/link-to-documentation';
export const toc = [{
  depth: 2,
  url: "#개발-작업-구성",
  title: _jsx(_Fragment, {
    children: "개발 작업 구성"
  })
}, {
  depth: 3,
  url: "#dev-전에-설정-작업-실행",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "dev"
    }), " 전에 설정 작업 실행"]
  })
}, {
  depth: 3,
  url: "#특정-애플리케이션-실행",
  title: _jsx(_Fragment, {
    children: "특정 애플리케이션 실행"
  })
}, {
  depth: 2,
  url: "#터미널-ui-사용",
  title: _jsx(_Fragment, {
    children: "터미널 UI 사용"
  })
}, {
  depth: 3,
  url: "#보기-사용자-지정",
  title: _jsx(_Fragment, {
    children: "보기 사용자 지정"
  })
}, {
  depth: 3,
  url: "#작업과-상호작용",
  title: _jsx(_Fragment, {
    children: "작업과 상호작용"
  })
}, {
  depth: 2,
  url: "#watch-mode",
  title: _jsx(_Fragment, {
    children: "Watch Mode"
  })
}, {
  depth: 2,
  url: "#제한-사항",
  title: _jsx(_Fragment, {
    children: "제한 사항"
  })
}, {
  depth: 3,
  url: "#teardown-작업",
  title: _jsx(_Fragment, {
    children: "Teardown 작업"
  })
}, {
  depth: 2,
  url: "#다음-단계",
  title: _jsx(_Fragment, {
    children: "다음 단계"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "모노레포에서 애플리케이션을 개발하면 강력한 워크플로를 활용할 수 있으며, 소스 제어에 원자적 커밋을 만들고 코드에 쉽게 액세스할 수 있습니다."
    }), "\n", _jsx(_components.p, {
      children: "대부분의 개발 작업은 코드 변경 사항을 감시하는 장기 실행 작업입니다. Turborepo는 강력한 터미널 UI 및 다음과 같은 기능으로 이 경험을 향상시킵니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsxs(_components.a, {
          href: "#configuring-development-tasks",
          children: [_jsx(_components.code, {
            children: "dev"
          }), " 작업 구성"]
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "#interacting-with-tasks",
          children: "작업과 상호작용"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "#watch-mode",
          children: "Watch Mode"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "#running-setup-tasks-before-dev",
          children: "설정 스크립트 실행"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "#running-a-specific-application",
          children: "작업 필터링하여 패키지 하위 집합 실행"
        })
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "개발-작업-구성",
      children: "개발 작업 구성"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo.json"
      }), "에서 개발 작업을 정의하면 Turborepo에 장기 실행 작업을 실행할 것임을 알립니다. 이는 개발 서버 실행, 테스트 실행 또는 애플리케이션 빌드와 같은 작업에 유용합니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "dev"
      }), " 작업을 등록하려면 두 가지 속성과 함께 ", _jsx(_components.code, {
        children: "turbo.json"
      }), "에 추가합니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"cache\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " false"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"persistent\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "\"cache\": false"
        }), ": Turborepo에 작업 결과를 캐시하지 않도록 지시합니다. 이는 개발 작업이므로 코드를 자주 변경할 가능성이 높기 때문에 결과를 캐시하는 것은 유용하지 않습니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "\"persistent\": true"
        }), ": Turborepo에 중지할 때까지 작업을 계속 실행하도록 지시합니다. 이 키는 터미널 UI가 작업을 장기 실행 및 대화형으로 처리하도록 신호 역할을 합니다. 또한 종료되지 않는 작업에 실수로 의존하는 것을 방지합니다."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["이제 ", _jsx(_components.code, {
        children: "dev"
      }), " 작업을 실행하여 개발 스크립트를 병렬로 시작할 수 있습니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " dev"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "dev-전에-설정-작업-실행",
      children: [_jsx(_components.code, {
        children: "dev"
      }), " 전에 설정 작업 실행"]
    }), "\n", _jsxs(_components.p, {
      children: ["개발 환경을 설정하거나 패키지를 미리 빌드하는 스크립트를 실행할 수도 있습니다. ", _jsx(_components.code, {
        children: "dependsOn"
      }), "을 사용하여 ", _jsx(_components.code, {
        children: "dev"
      }), " 작업 전에 해당 작업이 실행되도록 할 수 있습니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"cache\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " false"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"persistent\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"//#dev:setup\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"//#dev:setup\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"outputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\".codegen/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["이 예에서는 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/configuring-tasks#registering-root-tasks",
        children: "Root Task"
      }), "를 사용하고 있지만 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/configuring-tasks#depending-on-a-specific-task-in-a-specific-package",
        children: "패키지의 임의 작업"
      }), "에 동일한 아이디어를 사용할 수 있습니다."]
    }), "\n", _jsx(_components.h3, {
      id: "특정-애플리케이션-실행",
      children: "특정 애플리케이션 실행"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "--filter"
      }), " 플래그를 사용하면 ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#package-graph",
        children: "Package Graph"
      }), "의 하위 집합을 선택할 수 있으므로 특정 애플리케이션과 해당 종속성에 대한 ", _jsx(_components.code, {
        children: "dev"
      }), " 작업을 실행할 수 있습니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " dev"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter=web"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h2, {
      id: "터미널-ui-사용",
      children: "터미널 UI 사용"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo의 터미널 UI는 작업을 중심으로 고도로 대화형 경험을 만드는 여러 기능을 활성화합니다."
    }), "\n", _jsx(_components.h3, {
      id: "보기-사용자-지정",
      children: "보기 사용자 지정"
    }), "\n", _jsx(_components.p, {
      children: "키바인드를 사용하여 필요에 맞게 UI를 빠르게 조정할 수 있습니다."
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "키바인드"
          }), _jsx(_components.th, {
            children: "작업"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "m"
            })
          }), _jsx(_components.td, {
            children: "키바인드 목록 팝업 토글"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "↑"
            }), "/", _jsx(_components.code, {
              children: "↓"
            })]
          }), _jsx(_components.td, {
            children: "작업 목록에서 다음/이전 작업 선택"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "j"
            }), "/", _jsx(_components.code, {
              children: "k"
            })]
          }), _jsx(_components.td, {
            children: "작업 목록에서 다음/이전 작업 선택"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "p"
            })
          }), _jsx(_components.td, {
            children: "선택한 작업에 대한 선택 고정 토글"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "h"
            })
          }), _jsx(_components.td, {
            children: "작업 목록 표시 토글"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "c"
            })
          }), _jsx(_components.td, {
            children: "로그가 강조 표시되면 선택 항목을 시스템 클립보드에 복사"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "u"
            }), "/", _jsx(_components.code, {
              children: "d"
            })]
          }), _jsxs(_components.td, {
            children: ["로그 위", _jsx(_components.code, {
              children: "u"
            }), "/아래", _jsx(_components.code, {
              children: "d"
            }), "로 스크롤"]
          })]
        })]
      })]
    }), "\n", _jsx(_components.h3, {
      id: "작업과-상호작용",
      children: "작업과 상호작용"
    }), "\n", _jsx(_components.p, {
      children: "일부 도구는 입력을 입력할 수 있습니다. 이에 대한 예로는 Drizzle ORM의 대화형 마이그레이션 또는 Jest의 테스트 스위트 필터링 및 재실행이 있습니다."
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/reference/configuration#interactive",
        children: "대화형으로 표시"
      }), "된 작업과 상호작용하여 입력을 제공할 수 있습니다."]
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "키바인드"
          }), _jsx(_components.th, {
            children: "작업"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "i"
            })
          }), _jsx(_components.td, {
            children: "상호작용 시작"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "Ctrl+z"
            })
          }), _jsx(_components.td, {
            children: "상호작용 중지"
          })]
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "watch-mode",
      children: "Watch Mode"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://www.typescriptlang.org/docs/handbook/compiler-options.html#compiler-options",
        children: _jsx(_components.code, {
          children: "tsc --watch"
        })
      }), "와 같이 많은 도구에는 소스 코드의 변경 사항에 응답하는 내장 감시자가 있습니다. 그러나 일부는 그렇지 않습니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo watch"
      }), "는 모든 도구에 종속성 인식 감시자를 추가합니다. 소스 코드 변경 사항은 다른 모든 작업과 마찬가지로 ", _jsx(_components.code, {
        children: "turbo.json"
      }), "에 설명한 ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#task-graph",
        children: "the Task Graph"
      }), "를 따릅니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["예를 들어 다음 작업 및 스크립트와 함께 ", _jsx(_components.a, {
        href: "/docs/reference/create-turbo",
        children: _jsx(_components.code, {
          children: "create-turbo"
        })
      }), "와 같은 패키지 구조를 사용합니다:"]
    }), "\n", _jsxs(Tabs, {
      items: ["turbo.json", "packages/ui", "apps/web"],
      children: [_jsx(Tab, {
        value: "turbo.json",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"tasks\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"persistent\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: " true"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"cache\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: " false"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"lint\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"dependsOn\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"^lint\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "packages/ui",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"name\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"@repo/ui\""
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "  \"scripts\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: ": {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"tsc --watch\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"lint\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"eslint .\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "apps/web",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"name\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"web\""
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "  \"scripts\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: ": {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"next dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"lint\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"eslint .\""
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"dependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"@repo/ui\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"workspace:*\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo watch dev lint"
      }), "를 실행하면 ESLint에 내장 감시자가 없음에도 불구하고 소스 코드를 변경할 때마다 ", _jsx(_components.code, {
        children: "lint"
      }), " 스크립트가 다시 실행됩니다. ", _jsx(_components.code, {
        children: "turbo watch"
      }), "는 내부 종속성도 인식하므로 ", _jsx(_components.code, {
        children: "@repo/ui"
      }), "의 코드 변경 사항은 ", _jsx(_components.code, {
        children: "@repo/ui"
      }), "와 ", _jsx(_components.code, {
        children: "web"
      }), " 모두에서 작업을 다시 실행합니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "web"
      }), "의 Next.js 개발 서버와 ", _jsx(_components.code, {
        children: "@repo/ui"
      }), "의 TypeScript 컴파일러 내장 감시자는 ", _jsx(_components.code, {
        children: "persistent"
      }), "로 표시되어 있으므로 평소와 같이 계속 작동합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["자세한 내용은 ", _jsxs(_components.a, {
        href: "/docs/reference/watch",
        children: [_jsx(_components.code, {
          children: "turbo watch"
        }), " 참조"]
      }), "를 방문하세요."]
    }), "\n", _jsx(_components.h2, {
      id: "제한-사항",
      children: "제한 사항"
    }), "\n", _jsx(_components.h3, {
      id: "teardown-작업",
      children: "Teardown 작업"
    }), "\n", _jsxs(_components.p, {
      children: ["경우에 따라 ", _jsx(_components.code, {
        children: "dev"
      }), " 작업이 중지될 때 스크립트를 실행할 수 있습니다. ", _jsx(_components.code, {
        children: "dev"
      }), " 작업이 종료될 때 ", _jsx(_components.code, {
        children: "turbo"
      }), "가 종료되기 때문에 Turborepo는 종료 시 해당 teardown 스크립트를 실행할 수 없습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["대신 기본 ", _jsx(_components.code, {
        children: "turbo dev"
      }), " 작업을 종료한 후 별도로 실행하는 ", _jsx(_components.code, {
        children: "turbo dev:teardown"
      }), " 스크립트를 만듭니다."]
    }), "\n", _jsx(_components.h2, {
      id: "다음-단계",
      children: "다음 단계"
    }), "\n", _jsx(_components.p, {
      children: "배포하려는 애플리케이션 버전이 있으면 Turborepo에서 환경 변수를 구성하는 방법을 알아볼 차례입니다."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
